import MarkerComment from "@/domain/MarkerComment";
import ClientBase from "../ClientBase";
import DashboardViewModel from "@/domain/dashboard/DashboardViewModel";
import AssetSummaryViewModel from "@/domain/dashboard/AssetSummaryViewModel";

class DashboardClient extends ClientBase {
    async getDashboardsByAssetId(assetId){
        const data = await this.get(`api/v1/dashboards/assets/${assetId}`);
        return data?.map(dashboard => new DashboardViewModel(dashboard)) ?? [];
    }

    async getModelVersionSummaryById(assetId){
        const data = await this.get(`api/v1/dashboarddata/assets/${assetId}/assetsummary`);
        return data ? new AssetSummaryViewModel(data) : null;
    }

    async getNewestCommentsByAssetId(assetId){
        const data = await this.get(`api/v1/dashboarddata/assets/${assetId}/markercomments`);
        return data?.map(comment => new MarkerComment(comment)) ?? [];
    }
}

export default new DashboardClient();